import { useState } from "react";
import logo from "../assets/logoH.png";
import {
  Alert,
  Chip,
  Divider,
  IconButton,
  InputLabel,
  InputAdornment,
  FormControl,
  OutlinedInput,
} from "@mui/material";
import FaceIcon from "@mui/icons-material/Face";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Spinner from "react-bootstrap/Spinner";

function Login(props) {
  const [datos, setDatos] = useState({
    noDocumento: "",
    clave: "",
  });

  /**Para el manejo del cbo de proyectos */
  const [mostrarDivProyecto, setMostrarDivProyecto] = useState(false);
  const [listaProyectos, setListaProyectos] = useState([]);
  const [cargando, setCargando] = useState(false);

  /***** Para el manejo del password *******/
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const asignarDato = (event) => {
    event.preventDefault();
    setDatos({ ...datos, [event.target.name]: event.target.value });
  };

  const autenticarse = async () => {
    try {
      props.socket.emit("autenticarse", datos, (response) => {
        if (
          response !== undefined &&
          response !== null &&
          response.length !== 0
        ) {
          if (response.toString().length > 0) {
            if (response[0].TipoParticipante === 1) {
              //Es super usuario
              props.acceder(response[0]);
            } else {
              if (response.length === 1) {
                //Se encuentra asociado a un solo proyecto
                props.acceder(response[0]);
              } else if (response.length > 1) {
                //Se encuentra asociado a varios proyectos
                setMostrarDivProyecto(true);
                setListaProyectos(response[0]);
              }
            }
          }
        } else {
          props.mostrarMsg([
            "No se encontró el Usuario!",
            "Por favor revise los datos de inicio de sesión.",
          ]);
        }
      });
    } catch (error) {
      setCargando(false);
      props.mostrarMsg("Regresó de autenticarse con el error: " + error);
    }

    // try {
    //   props.socket.emit("autenticarse", datos);

    // const response = await getAcceso(datos)
    // if(response.data.length < 1){
    //   props.mostrarMsg(["No se encontró al Usuario", "Por favor revise sus datos de acceso!"])

    // }else{        //Encontro al usuario
    //   if(response.data[0].TipoParticipante===1){  //Es super usuario
    //     props.acceder(response.data[0])

    //   }else{
    //      if(response.data.length === 1){  //Se encuentra asociado a un solo proyecto
    //         props.acceder(response.data[0])

    //       }else if(response.data.length > 1){   //Se encuentra asociado a varios proyectos
    //         setMostrarDivProyecto(true)
    //         setListaProyectos(response.data)
    //       }
    //   }
    // }
    // setCargando(false)
    // } catch (error) {
    //   setCargando(false);
    //   props.mostrarMsg(["ERROR", "Ocurrio un error al Autenticarse!", error]);
    // }
  };

  const enviarPerfil = (event) => {
    event.preventDefault();
    props.acceder(listaProyectos[event.target.value]);
  };

  const validarDatos = (event) => {
    event.preventDefault();
    setCargando(true);
    if (datos.noDocumento === "") {
      setCargando(false);
      props.mostrarMsg(["Por favor digite su Nombre de Usuario"]);
    } else if (datos.clave === "") {
      setCargando(false);
      props.mostrarMsg(["Por favor su Clave de acceso"]);
    } else {
      autenticarse();
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="row mt-5">
        <div className="card shadow">
          <div className="card-body">
            <div className="card-title">
              <img
                src={logo}
                className="img-fluid"
                alt="logo"
                style={{ width: 300 }}
              />
            </div>

            <div className="row mt-3 mb-3">
              <Alert severity="success">
                <strong>Administración y Seguimiento a Proyectos</strong>
              </Alert>
            </div>

            <div className="row">
              <FormControl fullWidth sx={{ m: 1 }}>
                <InputLabel htmlFor="noDocumento">
                  Nombre de usuario{" "}
                </InputLabel>
                <OutlinedInput
                  id="noDocumento"
                  name="noDocumento"
                  //startAdornment={<InputAdornment position="start">$</InputAdornment>}
                  label="Nombre de usuario"
                  value={datos.noDocumento}
                  onChange={asignarDato}
                />
              </FormControl>

              <FormControl fullWidth sx={{ m: 1 }}>
                <InputLabel htmlFor="clave">Clave de acceso</InputLabel>
                <OutlinedInput
                  id="clave"
                  name="clave"
                  value={datos.clave}
                  type={showPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Password visible"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Clave de acceso"
                  onChange={asignarDato}
                />
              </FormControl>
            </div>

            {mostrarDivProyecto && (
              <div className="row form-floating mb-3">
                <select
                  type="text"
                  className="form-control"
                  name="idProyecto"
                  onChange={(event) => {
                    enviarPerfil(event);
                  }}
                >
                  <option key="0" value="0">
                    Por favor seleccione un Proyecto...
                  </option>
                  {listaProyectos.map((reg, index) => {
                    return (
                      <option
                        key={index}
                        value={index}
                        label={reg.NbreProyecto}
                      >
                        {" "}
                        {reg.NbreProyecto}{" "}
                      </option>
                    );
                  })}
                </select>
                <label htmlFor="idProyecto">Seleccione un Proyecto</label>
              </div>
            )}

            {cargando === true && (
              <div>
                <Spinner
                  animation="grow"
                  variant="primary"
                  size="xl"
                  role="status"
                ></Spinner>
                <span className="visually">Un momento por favor...</span>
              </div>
            )}
          </div>

          <Divider />

          <div className="card-footer mb-3">
            {/* <div className="container">
              <div className="row"> */}
            <Chip
              color="primary"
              icon={<FaceIcon />}
              label="Ingresar"
              onClick={(event) => validarDatos(event)}
            />
          </div>
          {/* </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Login;
